<main class="container">
    <section id="column1" npSetLayout [pageLayout]="PageLayout.Layout12">
        <div class="row">
            <div class="col col-12">
                <update-application-form class="w-100"></update-application-form>
            </div>
        </div>
    </section>
</main>